import React from 'react';
import PropTypes from 'prop-types';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import { FormViewDecorator } from 'site-modules/shared/components/lead-form/unified-lead-form/views/form-view-decorator';
import { ZipCodeForm } from 'site-modules/shared/components/zip-code-form/zip-code-form';

import './lead-zip-form.scss';

function LeadZipFormUI({ creativeId = null, toggleZipForm, headerCopy = 'Save with Edmunds' }) {
  return (
    <Row className="lead-zip-form pos-r">
      <Col xs={12} md={7} className="module d-flex flex-column bg-white p-1 p-md-1_5 rounded-12">
        {!!headerCopy && <h2 className="heading-3 text-blue-50 mb-2">{headerCopy}</h2>}
        <ZipCodeForm
          trackingParent={`${creativeId}-ZIP`}
          onSuccess={toggleZipForm}
          colConfig={{ zip: { xs: 5, sm: 3, md: 4, lg: 3 }, btn: { xs: 'auto' } }}
          title="Enter location"
          subTitle="Enter a U.S. ZIP code for pricing near you."
          btnTitle="Continue"
          titleClassName="heading-4 mb-1"
          subTitleClassName="mb-1_5"
          zipInputClassName="size-16 py-0_5"
          btnClassName="ms-0_75"
          isErrorBelow
          fireWidgetView
        />
      </Col>
    </Row>
  );
}

LeadZipFormUI.propTypes = {
  toggleZipForm: PropTypes.func.isRequired,
  creativeId: PropTypes.string,
  headerCopy: PropTypes.string,
};

export const LeadZipForm = FormViewDecorator(LeadZipFormUI);
